const ProdutosForaEstoqueController = ControllerBase.extend({
    framework: "knockout",
    name: "ProdutosForaEstoqueController",

    ajax: function () {
        return {
            url: "/Produto/_ProdutosForaEstoque",
            type: "post",
            cache: false
        };
    },

    renderizado: function () {
        this.appendToModel({ name: "produtosSelecionados", value: [] });

        if (this.modoInclusao !== undefined && !this.modoInclusao) {
            $("#btn-aplicar").hide();
        }
    },

    antesBinding: function () {
        this.appendToModel({ name: 'PermitirSelecionar', value: this.permitirSelecionar });
        this.appendToModel({ name: "codigo", value: "" });
        this.appendToModel({ name: "descricao", value: "" });
        this.appendToModel({ name: "ordem", value: "" });
    },

    selecionar: function (model) {
        if (this.permitirSelecionar) {
            if (model.selecionado) {
                model.selecionado(!model.selecionado());
            } else {
                this.appendToModel({ name: "selecionado", value: true });
            }
        }
    },

    selecionarTodos: function () {
        if (!this.model.selecionarTodos) {
            this.appendToModel({ name: "selecionarTodos", value: true });
        } else {
            this.model.selecionarTodos(!this.model.selecionarTodos());
        }

        var self = this;

        $.each(this.model.produtos(), function () {
            this.selecionado(self.model.selecionarTodos());
        });
    },

    adicionar: function () {
        this.model.produtosSelecionados([]);

        var self = this;

        $.each(this.model.produtos(), function () {
            if (this.selecionado()) {
                self.model.produtosSelecionados.push(this);
            }
        });
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    aplicar: function () {
        var itens = this.toJS(this.model.produtosSelecionados());
        this.orcamento.adicionarItensForaEstoque(itens, this.itensAdicionadosCallback);
    },

    carregarPaginador: function (data) {
        var self = this;

        setTimeout(function () {
            this.paginador = new Paginator({
                container: "#produto-fora-orcamento",
                data: data,
                pageClickCallback: $.proxy(self.paginar, self)
            });
        });
    },

    paginar: function (e) {
        this.pesquisar(e.page);
    },

    search: function () {
        this.pesquisar(1);
    },

    pesquisar: function (pagina) {
        var self = this;

        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: pagina ? pagina : 1,
            Codigo: this.model.codigo(),
            Descricao: this.model.descricao(),
            Ordem: this.model.ordem()
        };

        if (this.model.selecionarTodos !== undefined)
            this.model.selecionarTodos(!this.model.selecionarTodos());

        global.ajax({
            url: "/Produto/ObterProdutosForaEstoque",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {
                var m = ko.mapping.fromJS(data.Entities);

                self.model.produtos(m());
                self.carregarPaginador(data);
            }
        });
    }
})

window.ProdutosForaEstoqueController = ProdutosForaEstoqueController

export {
    ProdutosForaEstoqueController
}